import { getHoseCodesFromDiastereotopicID, addDiastereotopicMissingChirality, groupDiastereotopicAtomIDs, } from 'openchemlib-utils';
export function getFilteredIDiaIDs(molecule, options) {
    const { maxSphereSize, diaIDs } = options;
    molecule.addImplicitHydrogens();
    molecule.addMissingChirality();
    addDiastereotopicMissingChirality(molecule);
    const molfile = molecule.toMolfile();
    let groupedDiaIDs = groupDiastereotopicAtomIDs(diaIDs, molecule, {
        atomLabel: 'C',
    });
    let carbonDiaIDs = groupedDiaIDs.sort((a, b) => {
        if (a.atomLabel === b.atomLabel) {
            return b.counter - a.counter;
        }
        return a.atomLabel < b.atomLabel ? 1 : -1;
    });
    const OCL = molecule.getOCL();
    for (const diaId of carbonDiaIDs) {
        diaId.hose = getHoseCodesFromDiastereotopicID(OCL.Molecule.fromIDCode(diaId.oclID), {
            maxSphereSize,
        });
    }
    let toReturn = {
        molfile,
        carbonDiaIDs: carbonDiaIDs,
    };
    return toReturn;
}
//# sourceMappingURL=getFilteredIDiaIDs.js.map